export default "__VITE_ASSET__EgBCjD2O__"